// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import dayjs from "dayjs"


// For CKEditor
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import './DocCmtDetailDialog.css';

export default function DocCmtDetailDialog(props) {

  const { open, onClose, docDetail } = props;

  const comments = docDetail?.Comments || [];

  const myEditorLockId = Symbol('my-editor-lock');

  const handleCloseClick = () => {
    onClose && onClose();
  }

  const [selComment, setSelComment] = useState(null);

  const [tabValue, setTabValue] = useState("0");

  const handleTabChange = (event, aTabValue) => {
    setTabValue(aTabValue);
    setSelComment(comments[aTabValue]);

  };

  // Use when "open" changed
  useEffect(() => {
    // console.log("useEffect DocCmtDetailDialog(open)");

    if (open && docDetail) {
      // console.log("init editor", docDetail);

      setTabValue("0");
      if (comments.length > 0) {
        setSelComment(comments[0]);
      } else {
        setSelComment(null);
      }

    }

  }, [open])


  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"xl"}
      aria-describedby="comment-details-dialog-description"
    >

      <DialogContent>

        <Box sx={{ flexDirection: 'column', height: "80vh" }} >
          <Grid container spacing={{ xs: 1 }}  >
            <Grid item xs={12}>
              Document Details
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField size="small"
                label="Document Date"
                value={docDetail.DocDate?.format(DmsCommon.SHORT_DATE_FORMAT) || ""}
                fullWidth InputProps={{ readOnly: true, }} InputLabelProps={{ shrink: true, }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField size="small"
                label="Ref. No"
                value={docDetail.DocRef}
                fullWidth InputProps={{ readOnly: true, }} InputLabelProps={{ shrink: true, }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField size="small"
                label="Document Type"
                value={docDetail.DocType}
                fullWidth InputProps={{ readOnly: true, }} InputLabelProps={{ shrink: true, }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField size="small"
                label="Our Ref No"
                value={docDetail.OurRef}
                fullWidth InputProps={{ readOnly: true, }} InputLabelProps={{ shrink: true, }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField size="small"
                label="Subject"
                value={docDetail.Subject}
                fullWidth InputProps={{ readOnly: true, }} InputLabelProps={{ shrink: true, }}
                inputProps={{ maxLength: 200 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField size="small"
                label="Receive Date"
                value={docDetail.RecDate?.format(DmsCommon.SHORT_DATE_FORMAT) || ""}
                fullWidth InputProps={{ readOnly: true, }} InputLabelProps={{ shrink: true, }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField size="small"
                label="Sender"
                value={docDetail.Sender}
                fullWidth InputProps={{ readOnly: true, }} InputLabelProps={{ shrink: true, }}
              />

            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField size="small"
                label="File Location"
                value={docDetail.FileLocation}
                fullWidth InputProps={{ readOnly: true, }} InputLabelProps={{ shrink: true, }}
              />
            </Grid>

            <Grid item xs={12} sm={6} container spacing={1} >
              <Grid item xs={12} >
                <TextField size="small"
                  label="Company"
                  value={docDetail.Company}
                  fullWidth InputProps={{ readOnly: true, }} InputLabelProps={{ shrink: true, }}
                />
              </Grid>
              <Grid item xs={12} >
                <TextField size="small"
                  label="Recipient"
                  value={docDetail.Recipient}
                  fullWidth InputProps={{ readOnly: true, }} InputLabelProps={{ shrink: true, }}
                />

              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField size="small"
                label="Keywords"
                value={docDetail.Keywords}
                fullWidth
                multiline
                minRows={3.2}
                maxRows={3.2}
                InputProps={{ readOnly: true, }}
                InputLabelProps={{ shrink: true, }}
              />
            </Grid>



            <Grid item xs={12}>
              Comments
            </Grid>
            <Grid item xs={12}>
              <TabContext value={tabValue}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={handleTabChange} variant="scrollable" scrollButtons="auto" aria-label="Comments's tabs" >
                    {comments.map((cmt, idx) => {
                      return (<Tab key={cmt.id} label={`${idx + 1}`} value={`${idx}`} />)
                    })}
                  </TabList>

                  {selComment &&
                    <React.Fragment>
                      <Grid container spacing={1} sx={{ my: 1 }} >
                        <Grid item xs={12} sm={6} >
                          <TextField size="small"
                            label="Date"
                            value={dayjs(selComment.CreateDate)?.format(DmsCommon.SHORT_DATETIME_FORMAT) || ""}
                            fullWidth InputProps={{ readOnly: true, }} InputLabelProps={{ shrink: true, }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField size="small"
                            label="User"
                            value={selComment.CreatedBy}
                            fullWidth InputProps={{ readOnly: true, }} InputLabelProps={{ shrink: true, }}
                          />

                        </Grid>
                      </Grid>
                      <CKEditor
                        editor={ClassicEditor}
                        data={selComment.Html}

                        onReady={editor => {
                          editor.editing.view.change((writer) => {
                            writer.setStyle("height", "250px", editor.editing.view.document.getRoot());
                          })

                          // editor.isReadOnly = true;
                          editor.enableReadOnlyMode(myEditorLockId);

                          const toolbarElement = editor.ui.view.toolbar.element;
                          toolbarElement.style.display = 'none';

                        }}
                      />
                    </React.Fragment>

                  }



                </Box>


              </TabContext>
            </Grid>
          </Grid>


        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Close</Button>

      </DialogActions>
    </Dialog>

  );
}

DocCmtDetailDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  docDetail: PropTypes.object,
};


